import React from 'react';
import classNames from 'classnames';

import styles from './Text.scss';

export type TextProps = {
  as?: React.ElementType;
  title?: boolean;
  small?: boolean;
  ink?: boolean;
  className?: string;
  children: React.ReactNode;
};

function Text(props: TextProps) {
  const { as: Element = 'span', children, small, title, ink } = props;

  const className = classNames(props.className, styles.text, {
    [styles.small]: small,
    [styles.ink]: ink,
    [styles.title]: title,
  });

  return <Element className={className}>{children}</Element>;
}

export default React.memo(Text);
